export default "__VITE_ASSET__DtMQh4A4__"